import * as React from 'react';

export const BodyText = (props) => (
    <div className={props.animation} style={{ margin:'0px 100px 0px 100px', textAlign: 'center'}}>
        <p style={{ fontSize: 20}}>{props.children}</p>
    </div>
)


// WEBPACK FOOTER //
// ./src/components/marketing/components/BodyText.js